import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'iccOptions': null,
};

export const iccServiceRate = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ICC]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ICC]: (state, action) => ({
      ...state,
      'loading': false,
      'iccOptions': action.response.data,
    }),
    [ActionTypes.FETCHED_ICC_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'iccOptions': null,
    }),
  })(state, action);
};
